export default {
    background: "#eee",
    //blue: "#157efb",
    //green: "#2ebf68",
    black: "#2C2E2F",
    blue: "#007AFF",
    blackTransparent: "rgba(0.0, 0.0, 0.0, 0.7)",
    darkGrey: "#aaa",
    darkGreyText: "#838383",
    emerald: "#0e8d72",
    lightGreen: "#b9ffbe",
    green: "#22C064",
    grey: "#e0e0e0",
    lightGrey: "#eee",
    brightGrey: "#fafafa",
    red: "#EE315E",
    white: "#fff",
    yellow: "#ebc12b",
};
